import { Form, Icon, Input, Modal, Select } from 'antd';
import React, { useEffect } from 'react';
import useLoadFromHousingStock from '../../../../hooks/useLoadFromHousingStock';
import { useSelector } from 'react-redux';

const Container = ({ form, visible, onCancel, accountTypes }) => {
  const currentCompany = useSelector(
    (store) => store.debtsStore.currentCompany
  );

  const { mutateAsync, isLoading: isFetchingLoad } = useLoadFromHousingStock();

  const handleSubmit = async (e) => {
    e.preventDefault();

    form.validateFieldsAndScroll(async (err, fieldValues) => {
      if (err) {
        return;
      }

      const { loadingName, debt, typeAccountId } = fieldValues || {};

      const values = {
        companyId: currentCompany?.id,
        loadingName,
        typeAccountId,
        ...(!!debt ? { debt } : {}),
      };

      await mutateAsync(values);

      onCancel();
    });
  };

  useEffect(() => {
    if (!!accountTypes?.length && !form.getFieldValue('typeAccountId')) {
      form.setFieldsValue({ typeAccountId: accountTypes[0]?.id });
    }
  }, [accountTypes, form]);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      destroyOnClose
      title="Загрузка ЛС из жилого фонда"
      cancelText="Отмена"
      okText={isFetchingLoad ? <Icon type="loading" /> : 'Загрузить'}
    >
      <Form>
        <Form.Item label="Наименование загрузки:">
          {form.getFieldDecorator('loadingName', {
            rules: [
              {
                required: true,
                message: 'Пожалуйста укажите наименование загрузки',
              },
            ],
          })(<Input placeholder="Наименование загрузки" />)}
        </Form.Item>
        <Form.Item label="Тип ЛС:">
          {form.getFieldDecorator('typeAccountId', {
            rules: [
              {
                required: true,
                message: 'Пожалуйста укажите тип ЛС',
              },
            ],
          })(
            <Select>
              {accountTypes?.map((accountType) => (
                <Select.Option
                  key={accountType.id}
                  value={accountType.id}
                >
                  {accountType?.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Сумма долга свыше:">
          {form.getFieldDecorator('debt')(
            <Input
              placeholder="1000"
              type="number"
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ModalUploadByHoustingStock = Form.create('ModalUploadByHoustingStock')(
  Container
);

export default ModalUploadByHoustingStock;
